import React, { useState, useEffect} from 'react';
import LayoutNavSectionList from 'components/layout_and_quote_builder/LayoutNavSectionList.jsx';
import LayoutContext from 'components/contexts/LayoutContext.jsx';
import QuoteBuilderManagePanel from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderManagePanel.jsx';
import QuoteBuilderForm from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderForm.jsx';
import PresentedDielineOptions from 'components/layout_and_quote_builder/quote_builder/PresentedDielineOptions.jsx';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import MyEventListener from 'components/common/MyEventListener.jsx';
import { CacheProvider } from 'components/layout_and_quote_builder/quote_builder/CacheContext.jsx';
import ErrorBoundary from 'components/common/ErrorBoundary.jsx';

const ShowLayoutAndQuoteBuilderPage = ( {config, navSections, dimensionGroups, layoutOptions, formulaOptions, optionsUserEntered, unit, locale, theme, btn_action, dimension_texts_on_layouts_enabled, user_quote_id} ) => {
  const LayoutContextValues = {
    dimensionGroups: dimensionGroups,
    layoutOptions: layoutOptions,
    formulaOptions: formulaOptions,
    optionsUserEntered: optionsUserEntered,
    unit: unit,
    locale: locale,
    theme: theme,
    btn_action: btn_action,
    dimension_texts_on_layouts_enabled: dimension_texts_on_layouts_enabled,
  }

  const [count, setCount] = useState(1000);

  useEffect( () => {
    window.user_quote_id = user_quote_id
  }, [])

  MyEventListener([
    {
      key: 'quote_builder.count_changed',
      callback: (msg) => {  setCount( () => msg.detail ) }
    }
  ])

  return (
    <ErrorBoundary
      componentName="ShowLayoutAndQuoteBuilderPage"
      errorContext={{ user_quote_id: user_quote_id }}
    >
      <CacheProvider initialCache={window.user_quote_section_properties_cached}>
        <LayoutContext.Provider value={LayoutContextValues} >

            <div className={`${styles.component_container} container`} >

              <table className="table table-no-border sectionTable">
                <tbody>
                  <tr style={{ backgroundColor: '#ddd' }}>
                    <td colSpan="3" style={{ textAlign: 'right'  }}> <h3  style={{ marginRight: "10px" }}> Manage </h3> </td>
                  </tr>
                  <tr>
                    <td style={{ "width": "28%" }}> <QuoteBuilderForm config={config.customer} readOnly={window.user_quote_finalised} /> </td>
                    <td style={{ "width": "36%" }}> <QuoteBuilderForm config={config.general} readOnly={window.user_quote_finalised} /> <PresentedDielineOptions /> </td>
                    <td style={{ "width": "36%" }}> <QuoteBuilderManagePanel readOnly={window.user_quote_finalised} /> </td>
                  </tr>
                </tbody>
              </table>

              <table className="table table-no-border sectionTable">
                <tbody>
                  <tr style={{ backgroundColor: '#ddd' }}>
                    <td colSpan="2" style={{ textAlign: 'right'  }}> <h3  style={{ marginRight: "10px" }}>  {t('quote_builder.sections')} </h3> </td>
                  </tr>

                  <tr>
                    <td colSpan="2">
                      <LayoutNavSectionList navSections={navSections} count={count} config={config} /> <br /> <br />
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>


        </LayoutContext.Provider>
      </CacheProvider>
    </ErrorBoundary>
  )
};

export default ShowLayoutAndQuoteBuilderPage;
